import ConfirmDeleteActions from './ConfirmDeleteActions';

interface LmsDeleteConfirmModalProps {
  /** Title rendered in the modal heading (e.g. "Delete Module"). */
  title: string;
  /** Body copy describing the consequences of the delete. */
  message: string;
  /** Handler for the cancel button (verbatim from the call site). */
  onCancel: () => void;
  /** Handler for the confirm/delete button (verbatim from the call site). */
  onConfirm: () => void;
  /** Disabled + loading flag forwarded to the confirm button. */
  loading: boolean;
}

/**
 * Centered delete-confirmation modal used by the LMS pages: full-screen overlay
 * + white card with a heading, a message, and the shared
 * {@link ConfirmDeleteActions} button row (spinnerMode="replace").
 * Render conditionally at the call site (e.g. `{showDeleteConfirm && (...)}`)
 * so it only mounts when the modal should be visible.
 */
export default function LmsDeleteConfirmModal({
  title,
  message,
  onCancel,
  onConfirm,
  loading,
}: LmsDeleteConfirmModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
      <div className="w-full max-w-sm rounded-xl bg-white p-6 shadow-xl">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
        <p className="text-sm text-gray-600 mb-6">
          {message}
        </p>
        <ConfirmDeleteActions
          onCancel={onCancel}
          onConfirm={onConfirm}
          loading={loading}
          spinnerMode="replace"
        />
      </div>
    </div>
  );
}
